/**
 * ActionsStep.jsx
 * ===============
 * Action configuration for setup wizard
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import SetupWizard from './SetupWizard';
import ActionsPage from '../../pages/ActionsPage';

const ActionsStep = () => {
  const { appName } = useParams();

  return (
    <SetupWizard currentStepKey="actions">
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        border: '1px solid #E5E7EB',
        padding: '32px',
        marginBottom: '20px'
      }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '700',
          color: '#111827',
          marginBottom: '8px'
        }}>
          ⚡ Configure Actions
        </h2>
        <p style={{
          fontSize: '14px',
          color: '#6B7280',
          marginBottom: '24px'
        }}>
          Make your app interactive by adding actions to buttons and forms.
        </p>

        <div style={{
          padding: '24px',
          backgroundColor: '#F9FAFB',
          borderRadius: '8px',
          marginBottom: '24px'
        }}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#111827',
            marginBottom: '12px'
          }}>
            💡 Quick Tips:
          </h3>
          <ul style={{
            fontSize: '14px',
            color: '#6B7280',
            margin: 0,
            paddingLeft: '20px'
          }}>
            <li>Create actions for button clicks (Navigate, Show Message, etc.)</li>
            <li>Configure form submit actions (Save Data, Send Email)</li>
            <li>Set up API calls for external integrations</li>
            <li>Skip this step if you just need a simple display website</li>
          </ul>
        </div>
      </div>

      {/* Embed ActionsPage */}
      <ActionsPage appName={appName} />
    </SetupWizard>
  );
};

export default ActionsStep;
























